'use client';

import 'client-only';

import { ToolsResourcesFeature } from '../common/features/tools-resources-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsResourcesFeature = createUseFlag(ToolsResourcesFeature);
